import Countdown from "react-countdown";
import Zoom from 'react-medium-image-zoom';
import Description from "./detalle-description";
import hexToRgb from 'hex-to-rgb';
import DetalleOptions from './detalle-options';
import DetalleOptionsSimple from "./detalle-options-simple";
import classNames from "classnames";
import {MdZoomOutMap} from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import configStatic from "../config-static.json";
import moment from "moment-timezone";
import { CgPlayButtonO } from "react-icons/cg";
import Modal from "react-modal";
import {GrClose} from "react-icons/gr";
import Plyr from 'plyr';

const Detalle = ({data, coverage, cart, delivery})=> {
    const [counterRender, setCounterRender] = useState(null);
    const [imageURL, setImageURL] = useState(data.fotos[0].url);
    const [watchVideo, setwatchVideo] = useState(false);

    useEffect(() => {
        const today = new Date(),
            weekDay = today.getDay(),
            hour = today.getHours();
        let hourTo = 24;
        if (weekDay === 6) { // saturday
            if (hour < 13) {
                hourTo = 13;
            }
        } else { // monday to friday
            if (hour < 17) {
                hourTo = 17;
            }
        }
        const renderer = ({hours, minutes, seconds}) => {
            return (<span>Realiza tú pedido antes de {hours} hrs {minutes} min {seconds} seg.</span>)
        };
        setCounterRender(<Countdown suppressHydrationWarning
                                    date={new Date(today.getFullYear(), today.getMonth(), today.getDate(), hourTo, 0, 0)}
                                    renderer={renderer}/>)
    }, []);

    useEffect(()=>{
        if(watchVideo){
            setTimeout(()=>{
                const player = new Plyr('#player', { controls: ['fullscreen','pip'], muted: true, autoplay: true, loop: { active: true }});
            },100)
        }
    }, [watchVideo])

    const hx = (data?.hexadecimal) ? hexToRgb(data.hexadecimal) : '';
    const css = (data?.hexadecimal) ? `
        #${data.slug} .dycDetallePrice,
        #${data.slug} .dycDetalleTownselectedCity,
        #${data.slug} .dycDetallePriceLow,
        #${data.slug} .dycDetallePriceLow{
            color: ${data.hexadecimal}
        }
        #${data.slug} .dycDetalleCountdown b:after,
        #${data.slug} .dycDetalleTitle:after,
        #${data.slug} .dycDetalleDays li:hover,
        #${data.slug} .dycDetalleDays li.active,
        #${data.slug} .dycDropdown li:hover,
        #${data.slug} .dycDetalleDiscount,
        #${data.slug} .dycDetalleDatepicker.active, 
        #${data.slug} .dycDetalleDatepicker:hover{
            background-color: ${data.hexadecimal}
        }
        #${data.slug} .button{
            background-color: ${data.hexadecimal}
        }
        #${data.slug} .button:before,
        #${data.slug} .button:after{
            border-color: ${data.hexadecimal}
        }
        #${data.slug} .button:disabled{
            background-color: rgba(${hx[0]},${hx[1]},${hx[2]},.5);
        }
    ` : '';


    const getDeliverDay = () => {
        let today = new Date(),
            weekDay = today.getDay(),
            hour = today.getHours();
        if (weekDay === 0) { // sunday
            return 'LUNES';
        } else if (weekDay === 6) { // saturday
            if (hour < 13) {
                return 'HOY';
            } else {
                return 'LUNES';
            }
        } else { // monday to friday
            if (hour < 17) {
                return 'HOY';
            } else {
                return 'MAÑANA';
            }
        }
    };

    const price = (data && data.price && data.price.precio) ? data.price.precio : '';
    const priceUp = (data && data.price && data.price.precio_up) ?
        <span className="dycDetallePriceLow">{data.price.precio_up}</span> : '';
    const title = (isMobile = false) => {
        return <div className={classNames('hidden-sm',{'dycDetalleTitleMobile': isMobile})}>
            {isMobile ? <h2 className="dycDetalleTitle">{data.nombre}</h2> :
                <h1 className="dycDetalleTitle">{data.nombre}</h1>}
            <p className="dycDetalleCode">Código SKU: {data.slug}</p>
            {price && <p className="dycDetallePrice">{priceUp} <span>{price}</span></p>}
        </div>
    }

    const discountLabel = () => {
        if (data.price?.precio_up) {
            const {precio, precio_up} = data.price;
            const p = Math.round(((precio_up * 100) / precio) - 100);
            return <span className="dycDetalleDiscount">-{p}%</span>
        }
    }

    const labelFor14or10 = ()=>{
        const today = moment();
        const a = configStatic.scheduleLabels;
        const v = (data.available_feb14) ? "available_feb14" : ( data.available_may10 ? "available_may10" : false );
        if(v && !data.disabled){
            const staticv = a.filter((i)=> i.key === v).shift();
            if(today.isAfter(staticv.date_start) && today.isBefore(staticv.date_end)){
                return <span className="dycDetalleAvailable">{staticv.label}</span>
            }
            return false;
        }else{
            return false;
        }
    }

    return (
        <section className="dycDetalle marginBottom" id={data.slug}>
            <style>{css}</style>
            <div className="dycDetalleColumn">
                {title(true)}
                <div className="dycDetalleImage marginBottom">
                    {discountLabel()}
                    <div className="dycDetalleImageContainer">
                        {labelFor14or10()}
                        {( !labelFor14or10() && (data.isnew && !data.disabled)) && <span className="dycDetalleNew">Nuevo producto</span>}
                        {data.disabled && <span className="dycDetalleExhausted">Producto Agotado</span>}
                        <Zoom zoomMargin={32}>
                            <img src={imageURL.replace(/\/ch\//g, '\/xl\/')} className="dycDetalleImageImg"/>
                        </Zoom>
                    </div>
                    <div className="dycDetalleImageIcon">
                        <MdZoomOutMap/>
                    </div>
                </div>
                <ul className="dycDetalleThumbs marginBottom">
                    {data.fotos.map(i =>
                        <li key={i.id_foto}><img onClick={() => {setImageURL(i.url); setwatchVideo(false)}} src={i.url} alt={data.nombre}/></li>
                    )}
                    {
                        (data.video) && <li className="dycDetalleThumbs-video" onClick={()=> setwatchVideo(true)}><img src={data.fotos[0].url}/> <CgPlayButtonO /></li>
                    }
                </ul>
                <Description descripcion={data.descripcion} comentarios={data.comentarios}/>
            </div>
            <div className="dycDetalleColumn">
                {title()}
                <div className="dycDetalleCountdown marginBottom">
                    <span>ENTREGA GARANTIZADA: <b>{getDeliverDay()}</b></span>
                    {counterRender}
                </div>

                <div className="dycDetalleSteps">
                    {
                        (data?.complemento) ?
                            <DetalleOptionsSimple data={data}/>
                            :
                            <DetalleOptions coverage={coverage} data={data} cart={cart} delivery={delivery}/>
                    }
                </div>


            </div>
            {
                (data.video) && <Modal
                    isOpen={!!(watchVideo)}
                    className="dycModal dycModal-video"
                    overlayClassName="dycModalOverlay"
                    ariaHideApp={false}
                >
                    <div className="dycModalHeader">
                        <h1 className="dycModalTitle">Video de {data.nombre}</h1>
                        <span className="dycModalClose" onClick={() => {
                            setwatchVideo(false)
                        }}>
                <GrClose/>
            </span>
                    </div>
                    <div className="dycModalBody">
                        <video id="player" playsInline controls data-poster={data.fotos[0].url} width={100}
                               autoPlay={true}>
                            <source src={data.video} type="video/mp4"/>
                        </video>
                    </div>
                </Modal>
            }
        </section>
    )
};

export default Detalle;
